export default __webpack_public_path__ + "static/media/img-egt-crs.fc0af338.png";